export interface ExternalLink {
    id: string;
    label: string;
    href: string;
    description?: string;
}

export const externalLinksData: ExternalLink[] = [
    {
        id: "google-maps-sotet",
        label: "Google Maps (Pabellón del Sotet)",
        href: "(pegar URL)",
        description: "Ubicación del punto de encuentro en Fraga",
    },
    {
        id: "inscripcion-youevent",
        label: "Inscripción",
        href: "https://youevent.es/sport/inscripcion_competicion.asp?interfaz_minima=true&id_competicion=8585",
        description: "Enlace a YouEvent para inscribirse",
    },
    {
        id: "modificar-inscripcion",
        label: "Modificar inscripción",
        href: "https://youevent.es/sport/edit_inscripcion_solicitar_fei.asp?interfaz_minima=true&id_competicion=8585",
        description: "Modificar una inscripción existente",
    },
    {
        id: "recuperar-email",
        label: "Recuperar email confirmación",
        href: "https://youevent.es/sport/enviar_email_confirmacion.asp?interfaz_minima=true&idEvento=8585&accion=inicio",
        description: "Recuperar el email de confirmación de inscripción",
    },
    {
        id: "incidencias",
        label: "Incidencias inscripciones",
        href: "mailto:info@youevent.es",
        description: "Reportar incidencias con inscripciones",
    },
    {
        id: "soporte-consultas",
        label: "Soporte y Consultas",
        href: "https://docs.google.com/forms/d/e/1FAIpQLScYx3pSL-F-aUnqZ_CZO51BUcJbmQqW7xcgp60-vtn6XacgbA/viewform",
        description: "Formulario de contacto para dudas generales y soporte",
    },
    {
        id: "manual-inscripcion",
        label: "Manual de Inscripción",
        href: "/manual-inscripcion",
        description: "Guía paso a paso para realizar tu inscripción",
    },
    {
        id: "alojamientos",
        label: "Alojamientos",
        href: "/alojamientos",
        description: "Opciones de alojamiento recomendadas",
    },
    {
        id: "reglamento",
        label: "Reglamento",
        href: "/reglamento-general",
        description: "Lee el reglamento general del evento",
    },
    {
        id: "cancelar-inscripcion",
        label: "Solicitar Cancelación",
        href: "https://youevent.es/sport/desinscribir_Deportista.asp?interfaz_minima=true&id_competicion=8585",
        description: "Solicitar la baja de la inscripción",
    },
];
